import { createSlice } from "@reduxjs/toolkit";
import type { Location } from "../../models/CatLocation";

const LocationInitialState: {
  locations: Location[] | null;
} = {
  locations: null,
};

export const LocationReducer = createSlice({
  name: "__",
  initialState: LocationInitialState,
  reducers: {
    setLocations(state, { payload }) {
      state.locations = payload;
    },
  },
});
